import VideoSection from '../modules/video-section';

const sections = document.querySelectorAll('[data-video-section]');
const initVideoSections = sections => {
    if (!sections) return;
    sections.forEach(item => new VideoSection(item));
};

initVideoSections(sections);
